import { dicts } from '@/store/SimpleDictsNames';
import { checkStoreStatus } from '@/util/util';
import { refLoad } from './simple/simple.store';
import store from '@/store/store';
import { REF_NAME as PRODUCT_REF_NAME, REF_PATH as PRODUCT_REF_PATH }
  from './complex/product/Const';
import { loadSelectData } from '@/component/managment/users/user.store';
import { loadInterest } from '@/component/managment/interestrate/interestrate.store';

export function loadAddDicts() {
  dicts.forEach(dict => {
    checkStoreStatus(dict.toUpperCase(), dict.toLowerCase(), refLoad, 'INF');
  });
  checkStoreStatus(PRODUCT_REF_NAME, PRODUCT_REF_PATH, refLoad, 'INF');
  checkStoreStatus('users_select', 'users_select', loadSelectData);
  checkStoreStatus('interestrate', 'interestrate', loadInterest);
}

function checkIfNotLoaded(refName) {
  const status = store.getState().getIn(['storeStatus', refName]);
  if (!status || status.status != 'loaded') {
    return true;
  }
  return false;
}

export function areAllTheDictsLoaded() {
  let atleastOneIsMissing = false;
  dicts.forEach(dict => {
    if (checkIfNotLoaded(dict.toUpperCase())) {
      atleastOneIsMissing = true;
    }
  });
  if (checkIfNotLoaded(PRODUCT_REF_NAME)) {
    atleastOneIsMissing = true;
  }
  if (checkIfNotLoaded('users_select')) {
    atleastOneIsMissing = true;
  }
  return !atleastOneIsMissing;
}
